var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpirience1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1665 41.7778C43.1665 40.7411 43.5723 39.7468 44.2947 39.0138C45.017 38.2807 45.9968 37.8689 47.0184 37.8689H50.8702C51.8918 37.8689 52.8715 38.2807 53.5939 39.0138C54.3162 39.7468 54.7221 40.7411 54.7221 41.7778M45.0924 31.4644C45.0924 32.5011 45.4982 33.4954 46.2206 34.2284C46.943 34.9615 47.9227 35.3733 48.9443 35.3733C49.9659 35.3733 50.9456 34.9615 51.668 34.2284C52.3903 33.4954 52.7961 32.5011 52.7961 31.4644C52.7961 30.4277 52.3903 29.4335 51.668 28.7004C50.9456 27.9674 49.9659 27.5555 48.9443 27.5555C47.9227 27.5555 46.943 27.9674 46.2206 28.7004C45.4982 29.4335 45.0924 30.4277 45.0924 31.4644Z",
    stroke: "#008CB7",
    strokeWidth: 2.51598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2778 67.5556C58.2778 66.5189 58.6837 65.5246 59.406 64.7916C60.1284 64.0585 61.1081 63.6467 62.1297 63.6467H65.9815C67.0031 63.6467 67.9828 64.0585 68.7052 64.7916C69.4276 65.5246 69.8334 66.5189 69.8334 67.5556M60.2038 57.2422C60.2038 58.2789 60.6096 59.2732 61.3319 60.0062C62.0543 60.7393 63.034 61.1511 64.0556 61.1511C65.0772 61.1511 66.0569 60.7393 66.7793 60.0062C67.5016 59.2732 67.9075 58.2789 67.9075 57.2422C67.9075 56.2055 67.5016 55.2113 66.7793 54.4782C66.0569 53.7452 65.0772 53.3333 64.0556 53.3333C63.034 53.3333 62.0543 53.7452 61.3319 54.4782C60.6096 55.2113 60.2038 56.2055 60.2038 57.2422Z",
    stroke: "#008CB7",
    strokeWidth: 2.51598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1665 67.5556C27.1665 66.5189 27.5723 65.5246 28.2947 64.7916C29.017 64.0585 29.9968 63.6467 31.0184 63.6467H34.8702C35.8918 63.6467 36.8715 64.0585 37.5939 64.7916C38.3162 65.5246 38.7221 66.5189 38.7221 67.5556M29.0924 57.2422C29.0924 58.2789 29.4982 59.2732 30.2206 60.0062C30.943 60.7393 31.9227 61.1511 32.9443 61.1511C33.9659 61.1511 34.9456 60.7393 35.668 60.0062C36.3903 59.2732 36.7961 58.2789 36.7961 57.2422C36.7961 56.2055 36.3903 55.2113 35.668 54.4782C34.9456 53.7452 33.9659 53.3333 32.9443 53.3333C31.9227 53.3333 30.943 53.7452 30.2206 54.4782C29.4982 55.2113 29.0924 56.2055 29.0924 57.2422Z",
    stroke: "#008CB7",
    strokeWidth: 2.51598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9443 33.3333C61.3888 35.5556 64.4999 40.4445 64.9443 48.4445M64.9443 48.4445L66.7221 46.2222M64.9443 48.4445L62.7221 46.2222",
    stroke: "#008CB7",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0103 62.5871C51.8735 64.6708 47.4865 64.8724 42.0599 62.1479M42.0599 62.1479L42.8504 64.1545M42.0599 62.1479L44.3587 61.525",
    stroke: "#008CB7",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0557 33.3333C35.6112 35.5556 32.5001 40.4445 32.0557 48.4445M40.0557 33.3333H36.0557M40.0557 33.3333L39.1668 36.8889",
    stroke: "#008CB7",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirience1);
export default __webpack_public_path__ + "static/media/Expirience1.e8779fb683ab9570be990bb514584f28.svg";
export { ForwardRef as ReactComponent };